import {Injectable} from "@angular/core";

@Injectable()
export class FormatService{

    /**
     * reformat a url and make sure it started with HTTP
     * // TODO add https format
     * @param string
     * @returns {any}
     */
    urlIt(string){
        let prefix = 'http://';
        if (string.substr(0, prefix.length) !== prefix)
        {
            return prefix + string;
        }

        return string;
    }

    /**
     * go to a url
     * @param {string} url
     * @param {boolean} new_tab
     */
    gotToUrl(url: string, new_tab?: boolean){
        if(new_tab){
            window.open(this.urlIt(url), '_blank');
        }else{
            window.open(this.urlIt(url));
        }
    }

    toDollar(price: number){
        const pieces = parseFloat('' + price).toFixed(2).split('')
        let ii = pieces.length - 3;
        while ((ii -= 3) > 0) {
            pieces.splice(ii, 0, ',')
        }
        return '$' + pieces.join('');
    }

}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/services/format.service.ts